/* Normalise editorial CTA suffixes without replacing links, handlers or form controls. */
(() => {
  if (!document.body.classList.contains('template-index') || window.xmilesHomepageCtas) return;
  const main = document.getElementById('site-main');
  if (!main) return;
  window.xmilesHomepageCtas = true;

  const buttons = [
    '.xmiles-product-hero__button', '.xmiles-ph__action-button',
    '.xmiles-performance-feature__button', '.xmiles-performance-product__add',
    '.xmiles-performance-product__collection-link',
    '.hs-button:not(.hs-button--ghost)', '.hs-buy-panel button[type="submit"]',
    '.home-four-blocks-hover-product button[type="submit"]',
    '.xsvf-card__button', '.xm-team-invite__button', '.xmiles-live-deals__header-action'
  ].join(',');
  const links = [
    '.xmiles-product-hero__mobile-copy-link', '.xmiles-ph__what-is-link',
    '.xmiles-ph__member-message a', '.hs-button--ghost',
    'a.xmiles-section__nav-button.is-section-button', '.xmiles-collections__view-link',
    '.home-four-blocks-media-card__cta', '.xmiles-article__link', '.xm-inline-article__cta',
    '.xm-home-v2__link', '.xm-community__link', '.xm-community__source',
    '.xm-community__review-heading a', '.xmiles-live-deals__card-action',
    '.xmiles-live-deals__link', '.xmiles-live-deals__nested-link', '.xmiles-live-deals__manual a'
  ].join(',');
  const selector = `${buttons},${links}`;
  const suffix = /(?:\s*(?:›|»|→|>|&rsaquo;|&#8250;|&gt;))+\s*$/;

  function normalise(cta) {
    cta.dataset.xmHomeCta = cta.matches(buttons) ? 'button' : 'link';
    const walker = document.createTreeWalker(cta, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('[data-xm-home-chevron], svg, script, style')) continue;
      const clean = node.nodeValue.replace(suffix, '');
      if (clean === node.nodeValue) continue;
      if (!clean.trim() && node.parentElement !== cta && node.parentElement.getAttribute('aria-hidden') === 'true') {
        node.parentElement.dataset.xmHomeOldChevron = '';
      }
      node.nodeValue = clean;
    }
    let chevron = cta.querySelector(':scope > [data-xm-home-chevron]');
    if (!chevron) {
      chevron = document.createElement('span');
      chevron.dataset.xmHomeChevron = '';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '›';
    }
    if (cta.lastChild !== chevron) cta.append(chevron);
  }

  function collect(node, targets) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || !main.contains(element)) return;
    const parentCta = element.closest(selector);
    if (parentCta) targets.add(parentCta);
    element.querySelectorAll(selector).forEach(cta => targets.add(cta));
  }

  // Also covers Alpine label changes, variant availability and editor section replacements.
  const observer = new MutationObserver(records => {
    const targets = new Set();
    records.forEach(record => {
      collect(record.target, targets);
      record.addedNodes.forEach(node => collect(node, targets));
    });
    if (!targets.size) return;
    observer.disconnect();
    targets.forEach(normalise);
    observe();
  });
  function observe() { observer.observe(main, { childList: true, characterData: true, subtree: true }); }
  main.querySelectorAll(selector).forEach(normalise);
  observe();
})();

/* Paint adjacent Black Friday panels on the same gradient canvas. Live Deals
   owns the colour setting; dimensions and offsets keep the join continuous. */
(() => {
  if (!document.body.classList.contains('template-index') || window.xmilesCampaignBackgrounds) return;
  const main = document.getElementById('site-main');
  if (!main) return;
  window.xmilesCampaignBackgrounds = true;
  const properties = ['--xmiles-synced-campaign-background', '--xmiles-campaign-size', '--xmiles-campaign-position', '--xmiles-hero-campaign-position'];
  let painted = new Set();
  let frame = 0;
  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;

  function set(element, property, value) {
    if (element.style.getPropertyValue(property) !== value) element.style.setProperty(property, value);
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function sync() {
    frame = 0;
    const nextPainted = new Set();
    main.querySelectorAll('.xmiles-ph__container[data-xmiles-black-friday="true"]').forEach(performance => {
      const owner = performance.closest('.shopify-section');
      const nextSection = owner?.nextElementSibling;
      if (!nextSection?.classList.contains('shopify-section')) return;
      const deals = nextSection.querySelector('.xmiles-live-deals--black-friday');
      if (!deals) return;
      const performanceBox = performance.getBoundingClientRect();
      const dealsBox = deals.getBoundingClientRect();
      if (!performanceBox.width || !performanceBox.height || !dealsBox.width || !dealsBox.height) return;
      const gradient = getComputedStyle(deals).getPropertyValue('--xmiles-live-deals-gradient').trim();
      if (!gradient) return;

      const left = Math.min(performanceBox.left, dealsBox.left);
      const top = Math.min(performanceBox.top, dealsBox.top);
      const width = Math.max(performanceBox.right, dealsBox.right) - left;
      const height = Math.max(performanceBox.bottom, dealsBox.bottom) - top;
      const size = `${width}px ${height}px`;
      [[performance, performanceBox], [deals, dealsBox]].forEach(([element, box]) => {
        nextPainted.add(element);
        set(element, '--xmiles-campaign-size', size);
        set(element, '--xmiles-campaign-position', `${left - box.left}px ${top - box.top}px`);
        if (!painted.has(element)) resizeObserver?.observe(element);
      });
      set(performance, '--xmiles-synced-campaign-background', gradient);
      const hero = performance.querySelector('.xmiles-product-hero');
      if (hero && !hero.hidden) {
        const box = hero.getBoundingClientRect();
        const fade = getComputedStyle(hero, '::after');
        const fadeTop = box.bottom - (parseFloat(fade.bottom) || 0) - (parseFloat(fade.height) || 0);
        set(performance, '--xmiles-hero-campaign-position', `${left - box.left}px ${top - fadeTop}px`);
      }
    });
    painted.forEach(element => {
      if (nextPainted.has(element)) return;
      properties.forEach(property => element.style.removeProperty(property));
      resizeObserver?.unobserve(element);
    });
    painted = nextPainted;
  }

  resizeObserver?.observe(main);
  new MutationObserver(schedule).observe(main, { childList: true });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, schedule));
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('xmiles-performance-layout:update', schedule);
  sync();
})();
